<article class="article">
  <ion-row class="ion-justify-content-between align-items-center">
    <ion-col size-lg="4" size="12">
      <h2 class="h2">{{title}}</h2>
    </ion-col>
    <ion-col size-lg="6" size="12">
      <p>{{content}}</p>
    </ion-col>
  </ion-row>
</article>
